<template>
  <AppButton
    v-bind="$attrs"
    design="new"
    theme="info"
    type="button"
    class="ask-ai-button"
    @click.native="$emit('click', $event)"
  >
    <svg class="ask-ai-button__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="m10 3 2.3 6.7L19 12l-6.7 2.3L10 21l-2.3-6.7L1 12l6.7-2.3L10 3Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" />
      <path d="m19 1 1.1 3.9L24 6l-3.9 1.1L19 11l-1.1-3.9L14 6l3.9-1.1L19 1Z" fill="currentColor" />
    </svg>
    <span>Ask AI</span>
  </AppButton>
</template>

<script>
export default {
  name: 'AskAIButton',
  inheritAttrs: false
}
</script>

<style lang="scss" scoped>
.ask-ai-button {
  flex-shrink: 0;
  gap: 8px;
  font-weight: 600;
  box-shadow: 0 3px 10px rgba($ui-blue, .22);
}

.ask-ai-button__icon {
  display: block;
  flex-shrink: 0;
}
</style>
